import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function CartPage() {
  const { items, subtotal, totalItems, increment, decrement, remove, clear } = useCart();

  return (
    <section className="cart-page">
      <div className="cart-header">
        <h1>Your Cart</h1>
        <p>{totalItems} item(s) selected</p>
      </div>

      {!items.length ? (
        <article className="empty-cart">
          <h2>Your cart is empty</h2>
          <p>Add Ditoo-Pro from product page to continue checkout.</p>
          <Link to="/product" className="solid-btn">
            Go to Product
          </Link>
        </article>
      ) : (
        <div className="cart-layout">
          <div className="cart-list">
            {items.map((item) => (
              <article className="cart-item" key={item.id}>
                <img src={item.image} alt={item.name} />
                <div className="cart-item-copy">
                  <h3>{item.name}</h3>
                  <p>Color: {item.colorName}</p>
                  <p>₹ {item.price.toLocaleString('en-IN')}.00</p>
                </div>
                <div className="cart-item-controls">
                  <div className="qty-control">
                    <button type="button" onClick={() => decrement(item.id)}>
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button type="button" onClick={() => increment(item.id)}>
                      +
                    </button>
                  </div>
                  <button type="button" className="ghost-btn" onClick={() => remove(item.id)}>
                    Remove
                  </button>
                </div>
              </article>
            ))}
          </div>

          <aside className="cart-summary">
            <h2>Order Summary</h2>
            <div className="summary-row">
              <span>Subtotal</span>
              <strong>₹ {subtotal.toLocaleString('en-IN')}.00</strong>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <strong>Free</strong>
            </div>
            <div className="summary-row total">
              <span>Total</span>
              <strong>₹ {subtotal.toLocaleString('en-IN')}.00</strong>
            </div>

            <Link to="/checkout" className="solid-btn summary-cta">
              Proceed to Checkout
            </Link>
            <button type="button" className="ghost-btn" onClick={clear}>
              Clear Cart
            </button>
          </aside>
        </div>
      )}
    </section>
  );
}
